// extracted by mini-css-extract-plugin
export default {"loss-plane":"loss-plane_loss-plane__Eq2JY"};